export const TRANSLATIONS = {
  en: {
    selectWorkshops: "Select your workshops",
    confirmBtn: "Buy Tickets",
    contactInfo: "Contact Information",
    emailLabel: "Email *",
    emailDescription: "We'll send the ticket details to this email after successful payment.",
    mobileLabel: "Mobile Number",
    addressLabel: "Shipping Address For Invitation Card",
    checkoutBtn: "Checkout",
    cancelBtn: "Cancel",
    alertSelect: "Please select at least 1 workshop.",
    errorPrefix: "Error: ",
    placeholderEmail: "email@example.com",
    placeholderMobile: "0987654321",
    placeholderAddress: "Building, Street, City",
    sendCodeBtn: "Get verification code",
    sendCodeAlert: "Verification code sent to your email. Please check the Spam folder if you don't see it in your Inbox.",
    verifyCodeLabel: "Verification code",
    verificationPlaceholder: "Enter verification code",
    verifyBtn: "Validate",
    verifySuccess: "Verification successful.",
    verifyFailure: "Invalid verification code.",
    emailNotVerified: "Please verify your email before checkout.",
    invalidEmail: "Please enter a valid email address.",
    footerContactInfo: "GenX Workshop - Hoan Kiem Library, 42 Nha Chung Street, Hanoi city - Hotline: 0522590666",
    quantityLabel: "Quantity",
    orderSummary: "Your Order",
    orderTotal: "Total",
    orderWorkshops: "Selected Workshops",
    orderPrice: "Price",
    subscribeHeading: "Subscribe to get updates and offers",
    subscribeDescription: "If you're not ready to join the workshop but want to get updates and offers, please subscribe using the form below.",
    subscribeBtn: "Subscribe"
  },
  vi: {
    emailDescription: "Chi tiết vé sẽ được gửi tới email của bạn sau khi thanh toán thành công.",
    selectWorkshops: "Lựa chọn Workshops của bạn",
    confirmBtn: "Mua vé",
    contactInfo: "Thông tin liên hệ",
    emailLabel: "Email *",
    mobileLabel: "Số điện thoại",
    addressLabel: "Địa chỉ nhận vé",
    checkoutBtn: "Thanh toán",
    cancelBtn: "Hủy",
    alertSelect: "Vui lòng chọn ít nhất 1 workshop.",
    errorPrefix: "Lỗi: ",
    placeholderEmail: "email@abc.com",
    placeholderMobile: "0987654321",
    placeholderAddress: "số nhà, tên đường / phố, tỉnh / thành phố",
    sendCodeBtn: "Lấy mã xác nhận",
    sendCodeAlert: "Mã xác nhận đã được gửi đến email của bạn. Vui lòng kiểm tra hộp thư chính hoặc mục Spam",
    verifyCodeLabel: "Mã xác nhận",
    verificationPlaceholder: "Nhập mã xác nhận",
    verifyBtn: "Kiểm tra",
    verifySuccess: "Xác thực thành công.",
    verifyFailure: "Mã xác nhận không đúng.",
    emailNotVerified: "Vui lòng xác thực email.",
    invalidEmail: "Vui lòng nhập địa chỉ email hợp lệ.",
    footerContactInfo: "GenX Workshop - Thư viện Hoàn Kiếm, 42 Nhà Chung, Hà Nội - Hotline: 0522590666",
    quantityLabel: "Số lượng",
    orderSummary: "Đơn hàng của bạn",
    orderTotal: "Tổng",
    orderWorkshops: "Workshops đã chọn",
    orderPrice: "Đơn giá",
    subscribeHeading: "Đăng ký nhận tư vấn và ưu đãi",
    subscribeDescription: "Nếu bạn chưa sẵn sàng tham gia workshop nhưng muốn được tư vấn và nhận thông tin về các khuyễn mãi, hãy đăng ký form dưới đây.",
    subscribeBtn: "Đăng ký"
  }
};
